import * as actions from './actions';

const initialState = {
  loading: false,
  tenantId: undefined,
  businessContextId: undefined,
  data: [], // { campaignId, totalRecords, totalSuccess, totalCost, successRatePercent, campaign: {}}
  error: {
    message: null,
    raw: null
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_COMMUNICATION_DATA:
      return {
        ...state
      };
    case actions.CLEAR_COMMUNICATION_DATA_STORE:
      return {
        ...initialState,
        loading: true
      };

    case actions.GETTING_COMMUNICATION_DATA:
      return {
        ...state,
        loading: true,
        error: initialState.error
      };
    case actions.GETTING_COMMUNICATION_DATA_SUCCEEDED:
      return {
        ...state,
        loading: false,
        tenantId: action.communicationData.tenantId,
        businessContextId: action.communicationData.businessContextId,
        data: action.communicationData.data,
        error: initialState.error
      };
    case actions.GETTING_COMMUNICATION_DATA_FAILED:
      return {
        ...state,
        loading: true,
        error: {
          raw: action.error
        }
      };
    default:
      return state;
  }
};
